import { Tooltip, styled, TooltipProps } from '@mui/material';
import React from 'react';

const StudioClipActionTooltip = styled(
  ({ className, children, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }}>
      {children && <div>{children}</div>}
    </Tooltip>
  )
)(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.grey[900],
    color: theme.palette.common.white,
    borderRadius: 0,
    marginBottom: 0,
    marginTop: 7,
    border: `1px solid ${theme.mixins.palette.surfaces[4]}`,
  },
}));

export default StudioClipActionTooltip;
